
import SMRestClient from 'lib/SMRestClient';

class SMOptionalServiceResource {
  static inquiry(formData, completion) {
    const url = "/1/optional_service_inquiries.json";
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
    done(function(data, textStatus, xhr) {
      completion(data, null, xhr);
    }).
    fail(function(xhr, textStatus, error) {
      completion(null, error, xhr);
    });
  }
}
export default SMOptionalServiceResource;



// WEBPACK FOOTER //
// ./app/javascript/resources/SMOptionalServiceResource.js